import { ICaseDecision } from "../../caseDecisions/model/CaseDecision";
import { IGenericCodebookItem } from "../../codebooks/model/GenericCodebookItem";
import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";
import { ICasePhase } from "./CasePhase";

export interface TCourtCase {
  id: number;
  courtCaseNumber: string;
  caseDescription: string;
  anonymizedCaseDescription: string;
  casId: number;
  cphId: number;
  caseType: string;
  caseTypeDescription: string;
  type: string;
  casePhaseType: string;
  casePhaseTypeDescription: string;
  judge1: string;
  judge2: string;
  judge3: string;
  closedByJudge: string;
  caseBeginDate: Date;
  beginDate: Date;
  endDate: Date;
  caseStatus: string;
  caseClosingWay: string;
  decisions: ICaseDecision[];
  phases: ICasePhase[];
  connectionTypeId: number;
  source: string;
  hasCaseLawDocs: boolean;
  courtCaseType: IGenericCodebookItem;
  primaryDecisionId?: string;
}

export interface ICourtCase extends TCourtCase {}

const CourtCase = Model((model: TCourtCase): ICourtCase => {
  const _value: TCourtCase = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get courtCaseNumber() {
      return _value.courtCaseNumber;
    },
    set courtCaseNumber(value) {
      _value.courtCaseNumber = value;
    },
    get caseDescription() {
      return _value.caseDescription;
    },
    set caseDescription(value) {
      _value.caseDescription = value;
    },
    get casId() {
      return _value.casId;
    },
    set casId(value) {
      _value.casId = value;
    },
    get cphId() {
      return _value.cphId;
    },
    set cphId(value) {
      _value.cphId = value;
    },
    get caseType() {
      return _value.caseType;
    },
    set caseType(value) {
      _value.caseType = value;
    },
    get caseTypeDescription() {
      return _value.caseTypeDescription;
    },
    set caseTypeDescription(value) {
      _value.caseTypeDescription = value;
    },
    get type() {
      return _value.type;
    },
    set type(value) {
      _value.type = value;
    },
    get casePhaseType() {
      return _value.casePhaseType;
    },
    set casePhaseType(value) {
      _value.casePhaseType = value;
    },
    get casePhaseTypeDescription() {
      return _value.casePhaseTypeDescription;
    },
    set casePhaseTypeDescription(value) {
      _value.casePhaseTypeDescription = value;
    },
    get judge1() {
      return _value.judge1;
    },
    set judge1(value) {
      _value.judge1 = value;
    },
    get judge2() {
      return _value.judge2;
    },
    set judge2(value) {
      _value.judge2 = value;
    },
    get judge3() {
      return _value.judge3;
    },
    set judge3(value) {
      _value.judge3 = value;
    },
    get closedByJudge() {
      return _value.closedByJudge;
    },
    set closedByJudge(value) {
      _value.closedByJudge = value;
    },
    get caseBeginDate() {
      return _value.caseBeginDate;
    },
    set caseBeginDate(value) {
      _value.caseBeginDate = value;
    },
    get beginDate() {
      return _value.beginDate;
    },
    set beginDate(value) {
      _value.beginDate = value;
    },
    get endDate() {
      return _value.endDate;
    },
    set endDate(value) {
      _value.endDate = value;
    },
    get caseStatus() {
      return _value.caseStatus;
    },
    set caseStatus(value) {
      _value.caseStatus = value;
    },
    get caseClosingWay() {
      return _value.caseClosingWay;
    },
    set caseClosingWay(value) {
      _value.caseClosingWay = value;
    },
    get decisions() {
      return _value.decisions;
    },
    set decisions(value) {
      _value.decisions = value;
    },
    get phases() {
      return _value.phases;
    },
    set phases(value) {
      _value.phases = value;
    },
    get connectionTypeId() {
      return _value.connectionTypeId;
    },
    set connectionTypeId(value) {
      _value.connectionTypeId = value;
    },
    get source() {
      return _value.source;
    },
    set source(value) {
      _value.source = value;
    },
    get hasCaseLawDocs() {
      return _value.hasCaseLawDocs;
    },
    set hasCaseLawDocs(value) {
      _value.hasCaseLawDocs = value;
    },
    get courtCaseType() {
      return _value.courtCaseType;
    },
    set courtCaseType(value) {
      _value.courtCaseType = value;
    },
    get anonymizedCaseDescription() {
      return _value.anonymizedCaseDescription;
    },
    set anonymizedCaseDescription(value) {
      _value.anonymizedCaseDescription = value;
    },
    get primaryDecisionId() {
      return _value.primaryDecisionId;
    },
    set primaryDecisionId(value) {
      _value.primaryDecisionId = value;
    }
  };

  return ValidatableObject<ICourtCase>(_model);
});

export default CourtCase;
